export default __webpack_public_path__ + "static/media/PowellCatLocation-14.5e6addd1.jpg";